import { amOrPm } from "global/utils/amOrPm";
import { getDiaStrTurno } from "global/utils/diasTurno";
import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { showToaster } from "../../../global/context/action/toaster/toaster";
import { GlobalContext } from "../../../global/context/Provider";
import BotonSubir from "../../assets/images/generico/BotonSubir";
import BurguerMobile from "../../components/Genericos/BurguerMobile/BurguerMobile";
import HeaderbarHome from "../../components/Genericos/HeaderbarHome/HeaderbarHome";
import Loading from "../../components/Genericos/Loading/Loading";
import TurnoNoEncontrado from "../../components/Genericos/TurnoNoEcontrado/TurnoNoEncontrado";
import CardTurno from "../../components/Turnos/CardTurno/CardTurno";
import CardVideoLlamada from "../../components/Turnos/CardTurno/CardVideoLlamada";
import {
  wsGetMotivoCancelacion,
  wsGetMotivoCancelacionLaboratorio,
} from "../../context/Actions/motivoCancelacion/motivoCancelacion";
import { vcTokenReset } from "../../context/Actions/token/vcToken";
import { cancelacionReset } from "../../context/Actions/turnos/cancelacion";
import { finalizaTurnosDisponibles } from "../../context/Actions/turnos/turnosDisponibles";
import {
  limpiarCambioEstado,
  limpiarDatosMedico,
  limpiarListaMultimedia,
  limpiarMatriculaMedico,
  limpiarPlanKinesio,
  limpiarTipoTurno,
  limpiarUltimoTurno,
  resetIdTurnoSolicitud,
  resetKinesioFlag,
  wsGetTurnosPacienteQr,
  wsSolicitarDatosMedico,
} from "../../context/Actions/turnos/turnosPaciente";
import { PortalContext } from "../../context/Provider";
import "./ProximosTurnos.css";
import { loginTokenReset } from "_+_Portal/context/Actions/token/loginToken";
import {
  hideModal,
  hideModalAction,
  showModal,
} from "_+_Portal/context/Actions/modal/modal";
import { motion } from "framer-motion";
import ToasterV2 from "global/component/Genericos/Toaster/ToasterV2";

const ProximosTurnos = () => {
  const {
    turnosPacienteState,
    turnosPacienteDispatch,
    cancelacionState,
    cancelacionDispatch,
    mercadoPagoState,
    selectDropDownState,
    turnosDisponiblesDispatch,
    tokenState,
    motivoCancelacionDispatch,
    vcTokenDispatch,
    vcTokenState,
    textosState,
    motivoCancelacionState,
    tokenDispatch,
    modalDispatch,
  } = useContext(PortalContext);

  // Nuevo contexto
  const { authState, toasterDispatch, toasterState, configState } =
    useContext(GlobalContext);

  const history = useHistory();
  const [showBurguerMobile, setShowBurguerMobile] = useState(false);
  const [dropDownValue, setDropDownValue] = useState(false);
  const [listaTurnos, setListaTurnos] = useState([]);
  const [loadingVC, setLoadingVC] = useState(true);

  const widthWindow = window.innerWidth;
  const autorizado = sessionStorage.getItem("claveVerificada");

  const onShowBurguerHandle = () => {
    setShowBurguerMobile(true);
  };

  const onCloseBurguerMobile = (type) => {
    if (type === "open") setShowBurguerMobile(true);
    else setShowBurguerMobile(false);
  };
  const onClickBuscarTurnos = () => {
    if (configState.config.data.opcBuscadorTurnos && widthWindow > 1024) {
      history.push("/buscadorTurnos");
    } else {
      history.push("/consultamedica");
    }
  };

  const onClickClave = () => {
    showModal(
      "Genericos/PedirClave/PedirClave",
      {
        dissmiss: () => hideModal()(modalDispatch),
        dniPaciente: authState.auth.data.paciente.nro_documento,
        navigateTo: () => {},
        obtenerClave: () => modalNewClave(),
      },
      [],
      "centro",
      true
    )(modalDispatch);
  };

  const modalNewClave = (path, paso) => {
    hideModal()(modalDispatch);
    setTimeout(() => {
      showModal(
        "Auth/CambioPassword/CambioPassword",
        {
          texto: "",
          dissmiss: () => hideModal()(modalDispatch),
          pathModal: path,
          pasoModal: paso,
          navigateTo: () => {},
        },
        [],
        "centro",
        true
      )(modalDispatch);
    }, 10);
  };

  // ------------ Seteo del Paciente ----------------------
  const userProximoTurno =
    selectDropDownState.selectDropDown.selectGlobal.pacienteElegido;

  useEffect(() => {
    if (!selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
      cancelacionReset()(cancelacionDispatch);
      wsGetTurnosPacienteQr()(turnosPacienteDispatch);
    } else {
      setDropDownValue(userProximoTurno);
      wsGetTurnosPacienteQr()(turnosPacienteDispatch);
    }
    if (vcTokenState.vcToken.data) {
      // setPasoMultiTab(5)(multiTabDispatch);
    }
    return () => {
      vcTokenReset()(vcTokenDispatch);
    };
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (cancelacionState.cancelacion.cancelaTurno) {
      showToaster(
        {
          texto: "Turno cancelado correctamente",
          tipo: "success",
        },
        "centroArriba"
      )(toasterDispatch);
      if (!dropDownValue) {
        resetKinesioFlag()(turnosPacienteDispatch);
        wsGetTurnosPacienteQr()(turnosPacienteDispatch);
        cancelacionReset()(cancelacionDispatch);
      } else {
        resetKinesioFlag()(turnosPacienteDispatch);
        wsGetTurnosPacienteQr()(turnosPacienteDispatch);
        cancelacionReset()(cancelacionDispatch);
      }
    }
    //eslint-disable-next-line
  }, [cancelacionState.cancelacion.cancelaTurno]);

  useEffect(() => {
    if (cancelacionState.cancelacion.error) {
      showToaster(
        {
          texto: "Error al validar el turno para cancelar",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
      hideModal()(modalDispatch);
      setTimeout(() => {
        window.location.reload(false);
        cancelacionReset()(cancelacionDispatch);
      }, 3000);
    }
    //eslint-disable-next-line
  }, [cancelacionState.cancelacion.error]);

  useEffect(() => {
    //este time out es porque la libreria no escucha los cambios muy rapido
    setTimeout(() => {
      // hideAyuda()(ayudaDispatch);
      // displayAyuda("hidden");
      // displayAyudaMobile("hidden");
    }, 250);
    finalizaTurnosDisponibles()(turnosDisponiblesDispatch);
  }, []);

  useEffect(() => {
    wsGetMotivoCancelacionLaboratorio()(motivoCancelacionDispatch);
    wsGetMotivoCancelacion()(motivoCancelacionDispatch);
    //eslint-disable-next-line
  }, []);

  //--- solicito recargar turnos. Motivo: AbonarTurno
  const recargoTurnos = () => {
    if (!selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
      cancelacionReset()(cancelacionDispatch);
      wsGetTurnosPacienteQr()(turnosPacienteDispatch);
    } else {
      setDropDownValue(userProximoTurno);
      wsGetTurnosPacienteQr()(turnosPacienteDispatch);
    }
  };
  //-- finaliza recarga
  function obtenerFecha(fechaHora) {
    const fechaHoraObj = new Date(fechaHora); // Crear objeto Date a partir de la cadena de fecha y hora
    const anio = fechaHoraObj.getFullYear(); // Obtener el año
    const mes = ("0" + (fechaHoraObj.getMonth() + 1)).slice(-2); // Obtener el mes (se agrega 1 ya que los meses en JavaScript comienzan en 0)
    const dia = ("0" + fechaHoraObj.getDate()).slice(-2); // Obtener el día

    const fecha = anio + "-" + mes + "-" + dia; // Formatear la fecha

    return fecha;
  }

  useEffect(() => {
    if (tokenState.token.data && turnosPacienteState.turnosPaciente.data) {
      const { fecha_turno, centro, codigo } = tokenState.token.data;
      let turnoEncontrado = [];
      if (tokenState.token.data.idprotocolo > 0) {
        turnoEncontrado = turnosPacienteState.turnosPaciente.data.filter(
          (item) => item.idProtocolo === tokenState.token.data.idprotocolo
        );
      } else {
        turnoEncontrado = turnosPacienteState.turnosPaciente.data.filter(
          (item) => item.idturno === tokenState.token.data.idturno
        );
      }
      if (codigo === 11 || codigo === 14) {
        //Cancelacion turno/labo.
        if (turnoEncontrado.length > 0) {
          showModalCancelarTurno(turnoEncontrado[0]);
        } else {
          showToaster(
            {
              texto: "Error al cargar turno para cancelar.",
              tipo: "danger",
            },
            "centroArriba"
          )(toasterDispatch);
          loginTokenReset()(tokenDispatch);
        }
      } else if (codigo === 10) {
        //Confirmar turno.
        if (turnoEncontrado.length > 0) {
          let fecha = obtenerFecha(fecha_turno);
          let strRespuesta = `Turno confirmado correctamente. Fecha: ${fecha} Centro: ${centro}`;
          showToaster(
            {
              texto: strRespuesta,
              tipo: "success",
            },
            "centroArriba"
          )(toasterDispatch);
        } else {
          showToaster(
            {
              texto: "Error al cargar turno para confirmar.",
              tipo: "danger",
            },
            "centroArriba"
          )(toasterDispatch);
          loginTokenReset()(tokenDispatch);
        }
      } else if (codigo === 6 || codigo === 7) {
        //Subir foto orden turno/labo.
        if (turnoEncontrado.length > 0) {
          const { subeFotoOrden, tieneFotoOrden, estadoOrden } =
            turnoEncontrado[0];
          if (
            flgModal &&
            subeFotoOrden &&
            !tieneFotoOrden &&
            estadoOrden === "Pendiente"
          ) {
            showModal(
              "Genericos/ModalSubirOrden/ModalSubirOrden",
              {
                turno: turnoEncontrado[0],
                dissmiss: dissmiss,
              },
              {},
              "centro",
              true
            )(modalDispatch);
            setFlgModal(false);
          } else {
            showToaster(
              {
                texto: "La orden ya fue subida, verifique el estado del turno.",
                tipo: "success",
              },
              "centroArriba"
            )(toasterDispatch);
            loginTokenReset()(tokenDispatch);
          }
        } else {
          showToaster(
            {
              texto: "Error al cargar turno para subir orden",
              tipo: "danger",
            },
            "centroArriba"
          )(toasterDispatch);
          loginTokenReset()(tokenDispatch);
        }
      } else if (codigo === 5 || codigo === 15) {
        //Abonar turno/labo
        if (turnoEncontrado.length > 0) {
          const { monto, flgSaldada, subeFotoOrden, estadoOrden } =
            turnoEncontrado[0];
          if (
            monto > 0 &&
            !flgSaldada &&
            ((subeFotoOrden && estadoOrden === "Validado") || !subeFotoOrden)
          ) {
            const { idTurno, idProtocolo, fecha, hora, centro, especialidad } =
              turnoEncontrado[0];
            showModal(
              "Turnos/AbonaTurno/AbonaTurno",
              {
                idTurno,
                idProtocolo,
                monto,
                fecha,
                hora,
                centro,
                especialidad,
                dismiss: dissmiss,
              },
              {},
              "centro",
              true
            )(modalDispatch);
            setFlgModal(false);
          } else {
            showToaster(
              {
                texto: "La turno ya fue abonado.",
                tipo: "success",
              },
              "centroArriba"
            )(toasterDispatch);
            loginTokenReset()(tokenDispatch);
          }
        } else {
          showToaster(
            {
              texto: "Error al cargar turno para abonar",
              tipo: "danger",
            },
            "centroArriba"
          )(toasterDispatch);
          loginTokenReset()(tokenDispatch);
        }
      }
    }
  }, [tokenState.token.data, turnosPacienteState.turnosPaciente.data]);

  //seleccion token
  const [flgModal, setFlgModal] = useState(true);

  const dissmiss = () => {
    hideModal()(modalDispatch);
    loginTokenReset()(tokenDispatch);
    limpiarPlanKinesio()(turnosPacienteDispatch);
    limpiarDatosMedico()(turnosPacienteDispatch);
    limpiarListaMultimedia()(turnosPacienteDispatch);
    limpiarMatriculaMedico()(turnosPacienteDispatch);
    limpiarTipoTurno()(turnosPacienteDispatch);
    resetIdTurnoSolicitud()(turnosPacienteDispatch);
    localStorage.setItem("alertaActive", "false");
  };

  const showModalCancelarTurno = (turno) => {
    if (!cancelacionState.cancelacion.error) {
      showModal(
        "Turnos/MensajeCancelarTurno/MensajeCancelarTurno",
        {
          titulo: "Cancelar turno",
          texto: `Desea cancelar ${
            turno.videoConsulta === true ? "la video consulta" : "su turno"
          } de ${turno.especialidad} del ${getDiaStrTurno(
            turno.fecha
          )} ${getDiaStrTurno(turno.fecha, true)} a las ${turno.hora} ${amOrPm(
            turno.hora
          )} ?`,
          items: turno.idProtocolo
            ? motivoCancelacionState.motivoCancelacion.laboratorio
            : motivoCancelacionState.motivoCancelacion.turnos,
          idturno: turno.idturno,
          idProtocolo: turno.idProtocolo,
          idTurnoSesion: turno.idTurnoSesion,
          idPacienteFamiliar: turno.idPacienteFamiliar,
        },
        {},
        "centro",
        true
      )(modalDispatch);
    }
  };

  const verificarHorario = (objeto) => {
    // Obtener la hora actual
    const horaActual = new Date();

    // Obtener la hora del objeto
    const horaObjeto = new Date(objeto.fecha);

    // Dividir la hora y los minutos de la cadena
    const [hora, minutos] = objeto.hora.split(":");

    // Establecer la hora y los minutos en la fecha del objeto
    horaObjeto.setHours(parseInt(hora, 10), parseInt(minutos, 10));

    // Agregar minutosToleranciaRecepcion a la hora del objeto
    horaObjeto.setMinutes(
      horaObjeto.getMinutes() +
        configState.config.data.minutosToleranciaRecepcion
    );

    // Si la hora actual es posterior a la hora del objeto + minutosToleranciaRecepcion, retorno falso (es decir, muestro el turno)
    if (horaActual > horaObjeto) {
      return false;
    } else {
      return true;
    }
  };

  const verificarHorarios = (listaObjetos) => {
    const horaActual = new Date();
    const minutosTolerancia =
      configState.config.data.minutosToleranciaRecepcion;
    const objetosValidos = [];

    listaObjetos.forEach((objeto) => {
      const horaObjeto = new Date(objeto.fecha);
      const [hora, minutos] = objeto.hora.split(":");

      horaObjeto.setHours(parseInt(hora, 10), parseInt(minutos, 10));
      horaObjeto.setMinutes(horaObjeto.getMinutes() + minutosTolerancia);

      if (horaActual <= horaObjeto) {
        objetosValidos.push(objeto);
      }
    });

    return objetosValidos;
  };

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  const modalSubidaOrden = (turno) => {
    showModal(
      "Genericos/ModalSubirOrden/ModalSubirOrden",
      {
        idturno: turno.idturno,
        idProtocolo: turno.idProtocolo,
        monto: turno.monto,
        flgSaldada: turno.flgSaldada,
        flg: true,
        medSolicitanteDto: turno.medSolicitanteDto,
        dissmiss: () => cerrarOrden(turno),
        turno,
      },
      {},
      "centro",
      true
    )(modalDispatch);
  };

  const cerrarPrep = (turno) => {
    limpiarUltimoTurno()(turnosPacienteDispatch);
    hideModalAction(() => paso1(turno))(modalDispatch);
  };

  const paso1 = (turno) => {
    if (turno.subeFotoOrden && !turno.tieneFotoOrden) {
      modalSubidaOrden(turno);
    } else {
      modalMatricula(turno);
    }
  };

  const cerrarOrden = (turno) => {
    hideModalAction(() => paso2(turno))(modalDispatch);
  };

  const paso2 = (turno) => {
    localStorage.setItem("alertaActive", "false");
    if (
      !turno.flgSaldada &&
      turno.idturno === turnosPacienteState.turnosPaciente.ultimoTurno
    ) {
      modalMatricula(turno);
    } else {
      modalTurnoConfirmado(turno);
    }
  };

  const modalPreparacion = (turno) => {
    showModal(
      "Turnos/Preparaciones/Preparaciones",
      {
        titulo: "Preparaciones",
        preparacion: turno.preparacion,
        dissmiss: () => cerrarPrep(turno),
      },
      {},
      "centro",
      true
    )(modalDispatch);
  };

  const modalPreparacionLabo = (turno) => {
    showModal(
      "Turnos/ModalLaboPrep/ModalLaboPrep",
      {
        dissmiss: () => cerrarPrep(turno),
      },
      {},
      "centro",
      true
    )(modalDispatch);
  };

  const modalTurnoConfirmado = (turno) => {
    showModal(
      "Turnos/TurnoConfirmado/TurnoConfirmado",
      {
        titulo: "Turno Confirmado",
        fecha: turno.fecha,
        hora: turno.hora,
        medico: turno.medico,
        centro: turno.centro,
        ubicacion: turno.ubicacion,
        tipoTurno: turnosPacienteState.turnosPaciente.tipoTurno,
        dissmiss: dissmiss,
      },
      {},
      "centro",
      true
    )(modalDispatch);
  };

  const modalMatricula = (turno) => {
    if (turno?.medSolicitanteDto === null && turno?.subeFotoOrden === true) {
      showModal(
        "Turnos/MatriculaModal/MatriculaModal",
        {
          titulo: "Médico Solicitante",
          dissmiss: () => cerrarAbonar(turno),
          idturno: turno.idturno,
          idProtocolo: turno.idProtocolo,
          modalDatosMedico: (matricula) => datosMedico(matricula, turno),
        },
        {},
        "centro",
        true
      )(modalDispatch);
    } else {
      modalTurnoConfirmado(turno);
    }
  };

  const datosMedico = (matricula, turno) => {
    wsSolicitarDatosMedico(matricula, (isCorrect, data) =>
      showModalSolicitudDatos(isCorrect, data, turno)
    )(turnosPacienteDispatch);
  };

  const cerrarAbonar = (turno) => {
    localStorage.setItem("alertaActive", "false");
    hideModalAction(() => modalTurnoConfirmado(turno))(modalDispatch);
  };

  const showModalSolicitudDatos = (isCorrect, data, turno) => {
    if (isCorrect) {
      if (data === true) {
        showModal(
          "Turnos/MatriculaModal/SolicitarDatosModal",
          {
            titulo: "Datos de Médico Solicitante",
            dissmiss: () => dissmissSolicitud(turno),
            solicitarDatos: () => dissmissSolicitud(turno),
          },
          {},
          "centro",
          true
        )(modalDispatch);
        limpiarDatosMedico()(turnosPacienteDispatch);
        resetIdTurnoSolicitud()(turnosPacienteDispatch);
      } else if (data === false) {
        resetIdTurnoSolicitud()(turnosPacienteDispatch);
        limpiarDatosMedico()(turnosPacienteDispatch);
        modalTurnoConfirmado(turno);
      }
    } else {
      showToaster(
        {
          texto: "Error al solicitar datos",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
      hideModal()(modalDispatch);
    }
  };

  const dissmissSolicitud = (turno) => {
    limpiarDatosMedico()(turnosPacienteDispatch);
    limpiarMatriculaMedico()(turnosPacienteDispatch);
    limpiarCambioEstado()(turnosPacienteDispatch);
    hideModalAction(() => modalTurnoConfirmado(turno))(modalDispatch);
  };

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  useEffect(() => {
    if (turnosPacienteState.turnosPaciente.data) {
      setListaTurnos(
        verificarHorarios(turnosPacienteState.turnosPaciente.data)
      );
      setLoadingVC(false);
    }
  }, [turnosPacienteState.turnosPaciente.data]);

  useEffect(() => {
    if (autorizado === "true") {
      if (listaTurnos.length > 0) {
        const idturno = turnosPacienteState.turnosPaciente.ultimoTurno;
        const turnoEncontrado = listaTurnos.find(
          (turno) => turno.idturno === idturno
        );
        if (turnoEncontrado) {
          if (idturno) {
            if (
              turnoEncontrado.preparacion === null ||
              turnoEncontrado.preparacion === ""
            ) {
              if (
                turnoEncontrado.especialidad.toLowerCase() === "laboratorio"
              ) {
                // /// ---------------- PREPARACIONES HARCODEADA ---------------------------
                modalPreparacionLabo(turnoEncontrado);
                // ---------------- PREPARACIONES HARCODEADA ---------------------------
              } else {
                cerrarPrep(turnoEncontrado);
              }
            } else if (turnoEncontrado.preparacion !== "") {
              modalPreparacion(turnoEncontrado);
            }
          }
        }
      }
    } else {
      limpiarUltimoTurno()(turnosPacienteDispatch);
    }
  }, [listaTurnos]);

  return (
    <React.Fragment>
      {toasterState.toaster.show && <ToasterV2 />}
      <BurguerMobile
        onCloseBurguerMobile={onCloseBurguerMobile}
        showBurguerMobile={showBurguerMobile}
      />
      <HeaderbarHome onShowBurguerHandle={onShowBurguerHandle} />
      <div className="ptur-bodyContainer-proxTurnos">
        {/* <div className="ptur-mainSidebar">
          <Sidebar />
        </div> */}
        {window.location.pathname === "/videoConsulta" ? (
          <Loading
            dataLoading={loadingVC}
            color="c-white"
            descripcion={loadingVC && "Cargando turnos..."}
          />
        ) : (
          <Loading
            dataLoading={
              turnosPacienteState.turnosPaciente.loading ||
              cancelacionState.cancelacion.loading ||
              mercadoPagoState.mercadoPago.loading ||
              turnosPacienteState.turnosPaciente.cancelarSesion === true ||
              turnosPacienteState.turnosPaciente.flgOrden === true ||
              turnosPacienteState.turnosPaciente.data === null
            }
            color="c-white"
            descripcion={
              (turnosPacienteState.turnosPaciente.loading &&
                "Cargando turnos...") ||
              (turnosPacienteState.turnosPaciente.cancelarSesion === true &&
                "Cancelando turno...") ||
              (cancelacionState.cancelacion.loading && "Cancelando turno...") ||
              (mercadoPagoState.mercadoPago.loading && "Generando pago...") ||
              (turnosPacienteState.turnosPaciente.flgOrden &&
                "Subiendo orden...") ||
              (turnosPacienteState.turnosPaciente.data === null &&
                "Cargando turnos...")
            }
          />
        )}

        <div className="ptur-proxturnos-boxGrid">
          {listaTurnos?.length > 0 && (
            <div className="ptur-proxturnos-header">
              <div className="ptur-proxTurnos-contenedorBoton">
                <button
                  className="ptur-proxTurnos-botonTurno rb18m"
                  onClick={onClickBuscarTurnos}
                >
                  Tomar otro turno
                </button>
              </div>
            </div>
          )}

          <motion.div
            initial={{ opacity: 0, y: +100 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 100 }}
            transition={{ duration: 0.4 }}
            className="ptur-proxTurnos-body"
          >
            {autorizado === "true" ? (
              listaTurnos?.length > 0 ? (
                <motion.div
                  initial={{ opacity: 0, y: +100 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: 100 }}
                  transition={{ duration: 0.4 }}
                  className="ptur-proxTurnos-cards"
                >
                  {window.location.pathname === "/videoConsulta"
                    ? Array.isArray(listaTurnos) &&
                      listaTurnos.map((item, index) => {
                        return (
                          <React.Fragment key={index}>
                            {item.videoConsulta === true && (
                              <CardVideoLlamada
                                item={item}
                                itemVC={item.videoConsultaDto}
                                idPacienteFamiliar={dropDownValue}
                                recargoTurnos={recargoTurnos}
                              />
                            )}
                          </React.Fragment>
                        );
                      })
                    : Array.isArray(listaTurnos) &&
                      listaTurnos.map((item, index) => {
                        return (
                          <React.Fragment key={index}>
                            {item.videoConsulta === false &&
                              verificarHorario(item) && (
                                <CardTurno
                                  idPacienteFamiliar={
                                    selectDropDownState.selectDropDown
                                      .selectGlobal.pacienteElegido
                                      ? selectDropDownState.selectDropDown
                                          .selectGlobal.pacienteElegido.id
                                      : ""
                                  }
                                  recargoTurnos={recargoTurnos}
                                  turno={item}
                                />
                              )}
                          </React.Fragment>
                        );
                      })}
                </motion.div>
              ) : (
                <TurnoNoEncontrado
                  state={listaTurnos}
                  loadingState={turnosPacienteState.turnosPaciente}
                  texto={textosState.textos.data?.ofrecerBusqueda?.nombre}
                  recomendacion={
                    textosState.textos.data?.ofrecerBusqueda?.descripcion
                  }
                  txtBtn="Buscar un turno"
                  onClickTurnos={onClickBuscarTurnos}
                  showBtn={true}
                />
              )
            ) : (
              <div className="autorizarBox">
                <TurnoNoEncontrado
                  state={[]}
                  loadingState={false}
                  texto={"Atención"}
                  recomendacion={
                    "Para poder visualizar sus turnos, por favor ingrese su clave del portal web."
                  }
                  txtBtn="Poner clave"
                  onClickTurnos={onClickClave}
                  showBtn={true}
                />
              </div>
            )}

            {turnosPacienteState.turnosPaciente.loading ? (
              ""
            ) : (
              <div className="ptur-proxturnos-botonSubir">
                <BotonSubir body={"ptur-proxTurnos-body"} />
              </div>
            )}
          </motion.div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default ProximosTurnos;
